export const IMAGE_UPLOAD_ACCEPT = 'image/png, image/jpeg'

export const isAcceptedFile = (file: File, acceptedTypes: string[]) =>
    acceptedTypes.some(
        (type) => file.type === type || file.type.startsWith(type)
    )

export const isAcceptedImageUpload = (file: File) =>
    isAcceptedFile(file, ['image/png', 'image/jpeg'])
